import { s__ } from '~/locale';
import { getMilestone, formatIssueInput, getBoardQuery } from 'ee_else_ce/boards/boards_util';
import { setError } from '../graphql/cache_updates.js?vue3';
import BoardNewItem from './board_new_item.vue?vue3';
import ProjectSelect from './project_select.vue?vue3';
export default {
    name: 'BoardNewIssue',
    i18n: {
        errorFetchingBoard: s__('Boards|An error occurred while fetching board. Please try again.')
    },
    components: {
        BoardNewItem,
        ProjectSelect
    },
    inject: [
        'boardType',
        'fullPath',
        'isGroupBoard',
        'isEpicBoard'
    ],
    props: {
        list: {
            type: Object,
            required: true
        },
        boardId: {
            type: String,
            required: true
        }
    },
    emits: [
        'add-new-issue',
        'toggle-new-form'
    ],
    data () {
        return {
            selectedProject: {},
            board: {}
        };
    },
    apollo: {
        board: {
            query () {
                return getBoardQuery(this.boardType, this.isEpicBoard);
            },
            variables () {
                return {
                    fullPath: this.fullPath,
                    boardId: this.boardId
                };
            },
            update (data) {
                const { board } = data.namespace;
                return {
                    ...board,
                    labels: board.labels?.nodes
                };
            },
            error (error) {
                setError({
                    error,
                    message: this.$options.i18n.errorFetchingBoard
                });
            }
        }
    },
    computed: {
        disableSubmit () {
            return this.isGroupBoard ? !this.selectedProject.name : false;
        },
        projectPath () {
            return this.isGroupBoard ? this.selectedProject.fullPath : this.fullPath;
        }
    },
    methods: {
        submit ({ title }) {
            const labels = this.list.label ? [
                this.list.label
            ] : [];
            const assignees = this.list.assignee ? [
                this.list.assignee
            ] : [];
            const milestone = getMilestone(this.list);
            return this.addNewIssueToList({
                issueInput: {
                    title,
                    labelIds: labels?.map((l)=>l.id),
                    assigneeIds: assignees?.map((a)=>a?.id),
                    milestoneId: milestone?.id,
                    projectPath: this.projectPath
                }
            });
        },
        addNewIssueToList ({ issueInput }) {
            const { labels, assignee, milestone, weight } = this.board;
            const config = {
                labels,
                assigneeId: assignee?.id || null,
                milestoneId: milestone?.id || null,
                weight
            };
            const input = formatIssueInput(issueInput, config);
            if (!this.isGroupBoard) {
                input.projectPath = this.fullPath;
            }
            this.$emit('add-new-issue', input);
        },
        cancel () {
            this.$emit('toggle-new-form');
        }
    }
};
